import { Config } from "../../config/config";
import { CTAFunction } from "../cta/ctaFunction/CTAFunction";
import { Player } from "../player/Player";

interface GlobalVintomNamespace {
  cta: { [key: string]: CTAFunction };
  requestedResources: { [resourceLocation: string]: Promise<void> };
  Player: typeof Player;
}

// export declare var vintom: GlobalVintomNamespace;

const initialVintom: GlobalVintomNamespace = {
  cta: {},
  requestedResources: {},
  Player,
};

window[Config.vintomNamespace] = window[Config.vintomNamespace] || initialVintom;
export const vintom: GlobalVintomNamespace = window[Config.vintomNamespace];
